module.exports = __webpack_public_path__ + "img/Bias_villa_Cassius.5a7b0a2f.png";